export default __webpack_public_path__ + "static/media/tgmures-card.f46a5b2c.png";